<!-- 联想下拉组件 -->
<template>
  <div class="lenovo-input-module">
    <a-select
      :value="targetValue"
      :placeholder="placeholder"
      optionLabelProp="children"
      :autoClearSearchValue="true"
      :default-active-first-option="false"
      :show-arrow="false"
      :filter-option="false"
      :not-found-content="isShowNoData ? '暂无数据' : ''"
      :disabled="disabled"
      show-search
      allow-clear
      @change="handleChange"
      @search="handleSearch"
      :getPopupContainer="getPopupContainer"
      :style="{ width: width }"
      :mode="modeType"
    >
      <a-select-option
        v-for="(item, index) in backData"
        :key="index"
        :value="item.name"
        :parameter="item || ''"
      >
        <!-- {{ item.name.length > 20 ? item.name.slice(0, 17) + '...' : item.name }} -->
        {{ item.name }}
      </a-select-option>
    </a-select>
  </div>
</template>

<script>
import SELECTAPI from "@/api/select.js";

export default {
  name: "LenovoInputModule",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {
      type: [String, Array],
      // required: true,
    },
    // 传参KEY
    modelKey: {
      type: String,
      required: false,
      default: "name",
    },
    // 其他传参
    apiParams: {
      type: Object,
      required: false,
    },
    // 接口返回的参数名
    paramsListObj: {
      type: Object,
      required: false,
      default: () => {
        return {
          name: "name",
          id: "id",
        };
      },
    },
    // 区分哪个接口
    apiType: {
      type: String,
      required: true,
    },
    // 重置清空列表
    reset: {
      type: Boolean,
      required: false,
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      required: false,
    },
    // 联想下拉输入框的默认值
    defaultValue: {
      type: [String, Array],
      required: false,
    },
    // 联想下拉接口id码
    id: {
      type: String,
      required: false,
    },
    // 联想下拉接口名称
    name: {
      type: String,
      required: false,
    },
    // Select宽度
    width: {
      type: String,
      default: "100%",
      required: false,
    },
    // 菜单渲染父节点
    popupContainer: {
      type: String,
      required: false,
    },
    // 选择框默认文字
    placeholder: {
      type: String,
      required: false,
      default: "请输入",
    },
    // 设置Select 的模式为多选或标签
    modeType: {
      type: String,
      required: false,
      default: "default",
    },
    // // 联系下拉层级嵌套值
    // callback: {
    //   type: String,
    //   required: false,
    // },
  },
  data() {
    return {
      backData: [],
      isShowNoData: false,
      timeOutId: "", // 定时器
    };
  },
  computed: {
    // 当前选中的值
    targetValue: {
      get: function (val) {
        return this.value || undefined;
      },
      set: function (val) {
        this.$nextTick(function () {
          this.handleChange(val);
        });
      },
    },
  },
  mounted() {},
  methods: {
    // 获取菜单渲染父节点
    getPopupContainer(trigger) {
      if (this.popupContainer == "body") {
        // 相对body定位
        return document.body;
      } else {
        // 相对父级节点定位
        return trigger.parentNode;
      }
    },
    // 联想下拉搜索
    handleSearch(text) {
      this.isShowNoData = false;
      if (this.timeOutId) {
        clearTimeout(this.timeOutId);
      }
      const search = () => {
        if (text.trim() !== "") {
          this.timeOutId = setTimeout(() => {
            let input = {};
            input[this.modelKey] = text.trim();
            const params = Object.assign(input, this.apiParams);
            let paramsObj = {
              data: {
                params: {
                  ...params,
                },
              },
            };
            SELECTAPI[this.apiType](paramsObj, (callback) => {
              let list = [];
              if (callback.data.length > 0) {
                list = callback.data;
              }
              this.isShowNoData = true;
              this.backData = list.map((item) => ({
                ...item,
                name: item[this.paramsListObj.name],
                id: item[this.paramsListObj.id],
              }));
            });
          }, 100);
        } else {
          this.backData = [];
        }
      };
      search();
    },
    // 联想下拉选中
    handleChange(id, option) {
      let obj = {
        id: "",
        name: "",
      };
      if (!id) {
        this.$emit("change", null);
        this.isShowNoData = false;
      } else {
        if (this.modeType == "multiple") {
          let arr = [];
          let arrData = [];
          option &&
            option.map((item) => {
              arr.push(item.data.attrs.parameter.name)
              arrData.push(item.data.attrs.parameter)
            });
          this.$emit("change", arr, arrData);
        } else {
          
          let data = option ? option.data.attrs.parameter : "";
          obj = data;
          this.$emit("change", obj.name || "", obj);
        }
      }
    },
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        if (!newVal) {
          this.backData = [];
          this.isShowNoData = false;
        }
      },
      immediate: true,
      deep: true
    },
    // 联想下拉输入框的默认值
    defaultValue: {
      handler(newVal, oldVal) {
        if (newVal) {
          // this.handleSearch(newVal); // 联想下拉搜索
          this.$nextTick(function () {
            this.handleChange(newVal);
          });
        }
      },
      immediate: true,
    },
    reset(newVal) {
      if (newVal) {
        this.backData = [];
        this.isShowNoData = false;
      }
    },
  },
};
</script>
